import { render, staticRenderFns } from "./myModal.vue?vue&type=template&id=d6a746a4&scoped=true&"
import script from "./myModal.vue?vue&type=script&lang=js&"
export * from "./myModal.vue?vue&type=script&lang=js&"
import style0 from "./myModal.vue?vue&type=style&index=0&id=d6a746a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a746a4",
  null
  
)

export default component.exports